// components/VehicleHeader.vue
<template>
    <div class="vehicle-header mb-4">
        <div class="row">
            <!-- Foto e informações básicas do veículo -->
            <div class="col-md-5">

                <ImageVehicle :vehicle-data="vehicleData.vehicles"/>

                <div class="reservation-info mt-3">
                    <div class="reservation-id">
                        <span>Reserva ID:</span>
                        <strong>{{ vehicleData ? vehicleData.id : 'N/A' }}</strong>
                    </div>
                    <div class="status-container">
                        <span>Status:</span>
                        <span
                            class="status-badge"
                            :class="vehicleData && vehicleData.reserve_status ? getStatusClass(vehicleData.reserve_status.id) : ''"
                        >
                            <i class="status-icon" :class="getStatusIcon(vehicleData && vehicleData.reserve_status ? vehicleData.reserve_status.id : 0)"></i>
                            {{ vehicleData && vehicleData.reserve_status ? vehicleData.reserve_status.title : 'N/A' }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Informações da reserva -->
            <div class="col-md-7">
                <div class="reservation-details">
                    <div class="detail-row">
                        <div class="detail-label">
                            <i class="fas fa-user"></i> Reservado Para:
                        </div>
                        <div class="detail-value">
                            <span class="user-name">{{ vehicleData && vehicleData.user ? vehicleData.user.name : 'N/A' }}</span>
                            <button
                                v-if="showButtonUser"
                                class="btn btn-sm btn-light ml-2"
                                title="Dados do Usuário"
                                @click="openUserModal"
                            >
                                <i class="fas fa-user-circle"></i>
                            </button>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-label">
                            <i class="fas fa-calendar-check"></i> Retirada Estimada:
                        </div>
                        <div class="detail-value">{{ vehicleData ? vehicleData.retreat_date : 'N/A' }}</div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-label">
                            <i class="fas fa-calendar-alt"></i> Retirado em:
                        </div>
                        <div class="detail-value">
                            {{ vehicleData && vehicleData.checkout ? vehicleData.checkout.retreat_at : 'N/A' }}
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-label">
                            <i class="fas fa-calendar-check"></i> Devolução Estimada:
                        </div>
                        <div class="detail-value">{{ vehicleData ? vehicleData.devolution_date : 'N/A' }}</div>
                    </div>

                    <div class="detail-row" v-if="vehicleData && vehicleData.reserve_status && vehicleData.reserve_status.id == '5'">
                        <div class="detail-label">
                            <i class="fas fa-calendar-alt"></i> Devolvido em:
                        </div>
                        <div class="detail-value">
                            {{ vehicleData && vehicleData.checkin ? vehicleData.checkin.devoluted_at : 'N/A' }}
                        </div>
                    </div>

                    <div class="detail-row" v-if="vehicleData.km_traveled">
                        <div class="detail-label">
                            <i class="fas fa-tachometer-alt"></i> Km Rodados:
                        </div>
                        <div class="detail-value km-value">
                            <strong>{{ vehicleData.km_traveled }}</strong>
                        </div>
                    </div>

                    <!-- Informações do Motorista -->
                    <div class="detail-row" v-if="vehicleData && vehicleData.driver">
                        <div class="detail-label">
                            <i class="fas fa-user-tie"></i> Motorista:
                        </div>
                        <div class="detail-value">
                            <span class="driver-name">{{ vehicleData.driver.name }}</span>
<!--                            <button-->
<!--                                class="btn btn-sm btn-light ml-2"-->
<!--                                title="Dados do Motorista"-->
<!--                                @click="openDriverModal"-->
<!--                            >-->
<!--                                <i class="fas fa-id-card"></i>-->
<!--                            </button>-->
                        </div>
                    </div>

                    <!-- Informações dos Passageiros -->
                    <div class="detail-row" v-if="vehicleData && vehicleData.ride && vehicleData.ride.length > 0">
                        <div class="detail-label">
                            <i class="fas fa-users"></i> Passageiros:
                        </div>
                        <div class="detail-value">
                            <div class="passengers-container">
                                <div
                                    v-for="(passenger, index) in vehicleData.rideList"
                                    :key="passenger.id || index"
                                    class="passenger-item"
                                >
                                    <span class="passenger-name">{{ getPassengerName(passenger) }}</span>
                                    <span
                                        v-if="passenger.pivot && passenger.pivot.status"
                                        class="passenger-status"
                                        :class="getPassengerStatusClass(passenger.pivot.status)"
                                    >
                                        {{ getPassengerStatusText(passenger.pivot.status) }}
                                    </span>
                                </div>
                                <div class="passengers-count">
                                    <small class="text-muted">
                                        Total: {{ vehicleData.ride.length }} passageiro{{ vehicleData.ride.length !== 1 ? 's' : '' }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageVehicle from "../Components/ImageVehicle.vue";
export default {
    name: "VehicleHeader", // Nome do componente em inglês
    props: {
        vehicleData: {
            type: Object,
            default: () => ({})
        },
        showButtonUser: {
            type: Boolean,
            default: true
        }
    },
    components: {
        ImageVehicle
    },
    methods: {
        // openUserModal - emite evento para abrir modal do usuário
        openUserModal() {
            this.$emit("open-user-modal", this.vehicleData);
        },

        // formatNumber - formata números com separadores de milhar
        formatNumber(value) {
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        // getStatusClass - retorna a classe CSS para status da reserva
        getStatusClass(statusId) {
            const statusClasses = {
                '1': 'status-pending',   // Pendente
                '2': 'status-progress',  // Em andamento
                '3': 'status-approved',  // Aprovado
                '4': 'status-canceled',  // Cancelado
                '5': 'status-completed'  // Concluído
            };

            return statusClasses[statusId] || 'status-unknown';
        },

        // getStatusIcon - retorna o ícone para status da reserva
        getStatusIcon(statusId) {
            const statusIcons = {
                '1': 'fas fa-clock',          // Pendente
                '2': 'fas fa-spinner fa-spin', // Em andamento
                '3': 'fas fa-thumbs-up',      // Aprovado
                '4': 'fas fa-ban',            // Cancelado
                '5': 'fas fa-check-circle'    // Concluído
            };

            return statusIcons[statusId] || 'fas fa-question-circle';
        },

        // openDriverModal - emite evento para abrir modal do motorista
        openDriverModal() {
            if (this.vehicleData && this.vehicleData.driver) {
                this.$emit("open-user-modal", {
                    ...this.vehicleData,
                    user: this.vehicleData.driver
                });
            }
        },

        // getPassengerStatusClass - retorna a classe CSS para status do passageiro
        getPassengerStatusClass(status) {
            const statusClasses = {
                'confirmed': 'status-confirmed',
                'pending': 'status-pending',
                'rejected': 'status-rejected',
                'cancelled': 'status-cancelled'
            };
            return statusClasses[status] || 'status-unknown';
        },

        // getPassengerStatusText - retorna o texto para status do passageiro
        getPassengerStatusText(status) {
            const statusTexts = {
                'confirmed': 'Confirmado',
                'pending': 'Pendente',
                'rejected': 'Rejeitado',
                'cancelled': 'Cancelado'
            };
            return statusTexts[status] || status;
        },

        // getPassengerName - retorna o nome do passageiro
        getPassengerName(passenger) {
            if (!passenger) return 'N/A';
            if (passenger.name) return passenger.name;
            if (passenger.requester && passenger.requester.name) return passenger.requester.name;
            return 'N/A';
        }
    }
};
</script>

<style scoped>
/* Estilos para informações do motorista */
.driver-name {
    font-weight: 600;
    color: #2c3e50;
}

/* Container de passageiros */
.passengers-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.passenger-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #dee2e6;
}

.passenger-name {
    font-weight: 500;
    color: #495057;
}

.passenger-status {
    font-size: 0.75rem;
    padding: 2px 8px;
    border-radius: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

/* Status dos passageiros */
.status-confirmed {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.status-pending {
    background-color: #fff3cd;
    color: #856404;
    border: 1px solid #ffeaa7;
}

.status-rejected {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.status-cancelled {
    background-color: #e2e3e5;
    color: #6c757d;
    border: 1px solid #d6d8db;
}

.status-unknown {
    background-color: #f8f9fa;
    color: #6c757d;
    border: 1px solid #dee2e6;
}

.passengers-count {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px solid #dee2e6;
}

/* Responsividade */
@media (max-width: 768px) {
    .passenger-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .passenger-status {
        align-self: flex-end;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/VehicleHeader.vue